import { ThunkDispatch } from 'redux-thunk';
import { ActionType } from 'typesafe-actions';

import { SelectedUsers } from 'src/interfaces/entities/course-user';

import { getReportsByCourseId } from '../report/thunks';
import { RootReducer } from '../types';
import * as actions from './actions';
import {
  addCourseUsersRequest,
  disableByUserIdRequest,
  getUsersInCourseRequest,
  getUsersWithoutGroupRequest,
} from './api';

export const getUsersInCourse = (courseId: string, query: string) => {
  return async (dispatch: ThunkDispatch<RootReducer, null, ActionType<typeof actions>>) => {
    dispatch(actions.getUsersByCourseId.request(''));
    try {
      const response = await getUsersInCourseRequest({ courseId, query });
      if (response.error) {
        throw response;
      }
      return dispatch(
        actions.getUsersByCourseId.success({
          data: response.data,
          pagination: response.pagination,
        }),
      );
    } catch (error) {
      return dispatch(actions.getUsersByCourseId.failure(error));
    }
  };
};

export const disableByUserId = (courseId: string, userId: string, getReports?: boolean) => {
  return async (
    dispatch: ThunkDispatch<RootReducer, null, ActionType<typeof actions>>,
    getState: () => RootReducer,
  ) => {
    dispatch(actions.disableByUserId.request(''));
    try {
      const response = await disableByUserIdRequest({ courseId, userId });
      const courseUserState = getState().courseUser;
      const reportState = getState().report;
      if (response.error) {
        throw response;
      }
      if (response.data?._id) {
        if (getReports) {
          await dispatch(
            getReportsByCourseId(
              courseId,
              `&page=${reportState.pagination.page}&limit=${reportState.pagination.limit}${
                reportState.filterQuery.length ? reportState.filterQuery : null
              }`,
            ),
          );
        } else {
          await dispatch(
            getUsersInCourse(
              courseId,
              `?isActive=true&page=${courseUserState.pagination.page}&limit=${
                courseUserState.pagination.limit
              }${courseUserState.filterQuery.length ? courseUserState.filterQuery : null}`,
            ),
          );
        }
        dispatch(actions.disableByUserId.success(''));
      }
      return response;
    } catch (error) {
      dispatch(actions.disableByUserId.failure(error));
    }
  };
};

export const addCourseUsers = (courseId: string, users: SelectedUsers[]) => {
  return async (dispatch: ThunkDispatch<RootReducer, null, ActionType<typeof actions>>) => {
    dispatch(actions.disableByUserId.request(''));
    try {
      const promises = users.map((user) =>
        addCourseUsersRequest({
          id: courseId,
          data: { user: user.user?._id, role: user.role, isActive: true },
        }),
      );
      const responses = await Promise.all(promises);
      if (responses.some((response) => response.error)) {
        const response = responses.find((response) => response.error);
        throw response;
      }
      await dispatch(getUsersInCourse(courseId, '?isActive=true&limit=1000'));
      return dispatch(
        actions.addCourseUsers.success({
          data: responses.map((response) => response.data),
        }),
      );
    } catch (error) {
      return dispatch(actions.addCourseUsers.failure(error));
    }
  };
};

export const getUsersWithoutGroup = (courseId: string, query: string) => {
  return async (dispatch: ThunkDispatch<RootReducer, null, ActionType<typeof actions>>) => {
    dispatch(actions.getUsersWithoutGroup.request(''));
    try {
      const response = await getUsersWithoutGroupRequest({ courseId, query });
      if (response.error) {
        throw response;
      }
      return dispatch(
        actions.getUsersWithoutGroup.success({
          data: response.data,
          pagination: response.pagination,
        }),
      );
    } catch (error) {
      return dispatch(actions.getUsersWithoutGroup.failure(error));
    }
  };
};
